import './base';
import './src/captcha';
import './src/count';
import {
  Promocode
} from './src/promocode';
import {
  Tabs
} from './src/tabs';
import './src/handlers';
import './src/vk.subscribe';
import {
  updateBasketFromList
} from './src/action';
import {initSlider} from './src/photo-slider';


const promocode = new Promocode('.promocode__form');
const tabsRecommended = new Tabs('.tabs--recommended');
updateBasketFromList();
initSlider();
